export default __webpack_public_path__ + "static/media/template_business-man__0001_26---BenWu.c78f37dd.png";